import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const RefreshIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 18.5 16.547"
    >
      <defs>
        <clipPath>
          <rect width="18.5" height="16.547" transform="translate(0 0)" fill="none" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <path
            d="M14.519,12.471a7.526,7.526,0,1,1,1.278-4.2"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            y1="3.199"
            x2="1.951"
            transform="translate(15.8 5.154)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            x1="3.199"
            y1="1.951"
            transform="translate(12.601 6.402)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
